import Assistant from './assistant';

export const assistantService = Assistant;
